<template>
    <div>
        <el-table :data="tableData" style="width: 100%" :show-header="showHeader">
            <el-table-column :label="$t('product.column01')" width="120px" prop="code"></el-table-column>
            <el-table-column :label="$t('product.column02')" prop="pCode" width="300px"> </el-table-column>
            <el-table-column :label="$t('product.column03')" prop="describe"> </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        showHeader: {
            type: Boolean,
            default: true
        },
        tableData: {
            type: Array,
            default: []
        },
    },
    data() {
        return {

        }
    },
}
</script>
